import React, {Component} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom'
import {connect} from 'react-redux';
import Wallets from '../../views/Wallets';
import Transactions from '../../views/Transactions';
import TransactionPage from '../../views/TransactionPage';
import TransactionProof from '../../views/TransactionProof';
import Header from '../Header/';
import Loader from '../Common/Loader';
import AlertModal from '../Common/AlertModal'
import {Container} from 'reactstrap';
import {checkAuth, getAuthToken} from '../../utils';
import 'react-select/dist/react-select.css';
import {Api} from '../../api';
import DownloadApplet from "../../views/CertificateTypeSelection/CertificateTypeSelection";
import PersonalData from "../../views/PersonalData";
import CheckBalance from "../../views/CheckBalance/CheckBalance";
import ConfirmCompanies from "../../views/ConfirmCompanies/ConfirmCompanies";
import TransactionSelectCompany from "../../views/TransactionSelectCompany";
import SearchCompany from "../../views/SearchCompany";
import ConfirmEstonianCompany from "../../views/ConfirmEstonianCompany";
import SmartIdCodeSelection from "../../views/SmartIdCodeSelection";

const ACCESS_DENIED_TEXT = 'Sorry, you do not have a permission to access this page. Please contact your administrator.';

const AdminCheck = (WrappedComponent, adminAccess, props = null) => {
    if (adminAccess) {
        return WrappedComponent;
    } else {
        return <AlertModal isOpen={true}
                           text={ACCESS_DENIED_TEXT}
                           type='warning'
                           onClose={() => props.history.push(`/`)}/>
    }
};

class Protected extends Component {
    state = {
        isLoading: false,
        textLoading: null,
        isPermissionsLoaded: false,
    };

    componentDidMount() {
        const authToken = getAuthToken();
        this.handleLoader(true);

        Api.get(`applet/countries`, authToken).then((response) => {
            console.log(response, 'auth true')
            const {dispatch} = this.props;
            // dispatch(usersActions.permissions(response.data));
            // this.setState({isPermissionsLoaded: true});
            setTimeout(() => this.handleLoader(false), 200)
        }).catch((error) => {
            setTimeout(() => this.handleLoader(false), 200)
            checkAuth(error, this.props.history);
        });
    };

    handleLoader = (isLoading, textLoading = null) => {
        this.setState({isLoading, textLoading})
    };

    render() {

        const {isLoading, textLoading, isPermissionsLoaded} = this.state;
        const {permissions} = this.props;

        if (!getAuthToken()) {
            return <Redirect to="/"/>;
        }
        return (
            <div className="app">
                {isLoading && <Loader textLoading={textLoading}/>}
                <Header {...this.props}/>
                <div className="app-body">
                    <main className="main">
                        <Container fluid>
                            <Switch>
                                <Redirect exact from='/user' to={'/user/personal-data/certificate-type-selection'}/>
                                {/*path={`${match.path}/:topicId`}*/}

                                <Route path="/user/personal-data/certificate-type-selection"
                                       render={routeProps => <DownloadApplet {...routeProps}
                                                                             handleLoader={this.handleLoader}/>}/>
                                <Route path="/user/personal-data/select-smart-id-code"
                                       render={routeProps => <SmartIdCodeSelection {...routeProps}
                                                                             handleLoader={this.handleLoader}/>}/>
                                <Route path="/user/personal-data/search-for-companies"
                                       render={routeProps => <SearchCompany {...routeProps}
                                                                               handleLoader={this.handleLoader}/>}/>
                                <Route path="/user/personal-data/confirm-ee-company"
                                       render={routeProps => <ConfirmEstonianCompany {...routeProps}
                                                                            handleLoader={this.handleLoader}/>}/>
                                <Route path="/user/personal-data/confirm-companies"
                                       render={routeProps => <ConfirmCompanies {...routeProps}
                                                                           handleLoader={this.handleLoader}/>}/>
                                <Route path="/user/personal-data/wait-for-payment"
                                       render={routeProps => <CheckBalance {...routeProps}
                                                                              handleLoader={this.handleLoader}/>}/>
                                <Route path="/user/personal-data/info/:certificateId"
                                       render={routeProps => <PersonalData {...routeProps}
                                                                             handleLoader={this.handleLoader}/>}/>
                                <Route path="/user/personal-data/info"
                                       render={routeProps => <PersonalData {...routeProps}
                                                                              handleLoader={this.handleLoader}/>}/>
                                <Route path="/user/metamask"
                                       render={routeProps => <Wallets {...routeProps}
                                                                             handleLoader={this.handleLoader}/>}/>
                                <Route exact path="/user/transactions/proof"
                                       render={routeProps => <TransactionProof {...routeProps}
                                                                       handleLoader={this.handleLoader}/>}/>
                                <Route exact path="/user/transactions/selectCompany"
                                       render={routeProps => <TransactionSelectCompany{...routeProps}
                                           isLoading={isLoading} handleLoader={this.handleLoader}/>}/>
                                <Route path="/user/transactions/select"
                                       render={routeProps => <Transactions {...routeProps}
                                                                       handleLoader={this.handleLoader}/>}/>
                                <Route path="/user/transaction/transactionPage"
                                       render={routeProps => <TransactionPage {...routeProps}
                                                                              handleLoader={this.handleLoader}/>}/>
                                <Route path="/user/transaction/:transactionId"
                                       render={routeProps => <TransactionPage {...routeProps}
                                                                       handleLoader={this.handleLoader}/>}/>
                            </Switch>
                        </Container>
                    </main>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const {users} = state;
    return {
        permissions: users.permissions,
    };
}

export default connect(mapStateToProps)(Protected);



// WEBPACK FOOTER //
// ./src/components/Protected/Protected.js